var map = {
	"./klokantech": [
		7829,
		152,
		957,
		832,
		829
	],
	"./klokantech.ts": [
		7829,
		152,
		957,
		832,
		829
	],
	"./osm-vector-tiles": [
		6072,
		152,
		957,
		72
	],
	"./osm-vector-tiles.ts": [
		6072,
		152,
		957,
		72
	],
	"./reunion-raster": [
		8317,
		152,
		832,
		317
	],
	"./reunion-raster.ts": [
		8317,
		152,
		832,
		317
	],
	"./sync-init": [
		3327,
		152,
		832,
		327
	],
	"./sync-init.ts": [
		3327,
		152,
		832,
		327
	],
	"./velivole": [
		1545,
		152,
		957,
		832,
		545
	],
	"./velivole.ts": [
		1545,
		152,
		957,
		832,
		545
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9497;
module.exports = webpackAsyncContext;